import { createContext, useContext, type ReactNode } from 'react'
import { useTranslation } from '@/shared/contexts/TranslationContext'
import { useThemeState} from '@/shared/hooks/useThemeState'

export type Theme = 'light' | 'dark'

interface ThemeContextType {
  theme: Theme
  toggleTheme: () => Promise<void>
  loadingLabel: string
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export function ThemeProvider({ children }: { children: ReactNode }) {
  const { theme, mounted, toggleTheme } = useThemeState()
  const { t } = useTranslation()

  if (!mounted) return null

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
        loadingLabel: t('common.loading'),
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }

  return context
}